import { ChartBar } from "@phosphor-icons/react";
import CollapsibleSection from "@/components/admin/CollapsibleSection";

function Stat({ label, value, sub, accent }) {
  return (
    <div className={`border ${accent ? "border-[#FF1B91] bg-[#FF1B91]/5" : "border-white/10 bg-[#0F0F0F]"} p-5`}>
      <div className="text-[10px] uppercase tracking-[0.25em] text-white/50 font-bold mb-2">{label}</div>
      <div className={`font-display font-black text-4xl tracking-tight ${accent ? "text-[#FF1B91]" : "text-white"}`}>{value}</div>
      {sub && <div className="text-[11px] uppercase tracking-[0.2em] text-white/45 mt-1">{sub}</div>}
    </div>
  );
}

export default function StatsGrid({ stats, onRefresh }) {
  return (
    <CollapsibleSection
      id="stats"
      testId="admin-stats-collapsible"
      title={<><ChartBar size={18} weight="fill" className="text-[#FF1B91] inline mr-2" />Form submissions (leads)</>}
      subtitle="Leads from Pink Plan form, Coaching Intake, and other explicit opt-ins."
      onRefresh={onRefresh}
    >
      {!stats ? (
        <div className="text-white/50 text-sm">No stats yet.</div>
      ) : (
        <>
          <div data-testid="admin-stats" className="grid grid-cols-2 md:grid-cols-4 gap-4">
            <Stat label="Total leads" value={stats.total} />
            <Stat label="Last 7 days" value={stats.last_7_days} accent />
            <Stat label="Last 30 days" value={stats.last_30_days} />
            <Stat label="Top city" value={stats.top_cities?.[0]?.city || "—"} sub={stats.top_cities?.[0]?.count ? `${stats.top_cities[0].count} leads` : ""} />
          </div>
          {stats?.top_cities?.length > 0 && (
            <div className="mt-5">
              <h3 className="font-display font-black uppercase text-sm tracking-tight mb-3 text-white/70">Top cities</h3>
              <div className="flex flex-wrap gap-2">
                {stats.top_cities.map((c, i) => (
                  <div key={i} className="border border-white/10 bg-[#0F0F0F] px-4 py-2 text-sm">
                    {c.city} <span className="text-[#FF1B91] font-bold ml-2">{c.count}</span>
                  </div>
                ))}
              </div>
            </div>
          )}
        </>
      )}
    </CollapsibleSection>
  );
}
